"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findScrollContainer = exports.setupSafelyCallItemToID = exports.determineItemValue = exports.sharedOnStateChange = exports.sharedOnSelectedItemChange = void 0;
/**
 * Function for `onSelectedItemChange` shared between SingleSelect and MultiSelect
 * @param changes - changes from Downshift
 * @param isDisabled - is the Select disabled
 * @param onChange - onChange function provided by the consumer
 */
var sharedOnSelectedItemChange = function (changes, isDisabled, onChange) {
    if (!isDisabled) {
        if (onChange) {
            var changeName = void 0;
            var changeValue = void 0;
            if ('selectedItem' in changes) {
                changeName = 'selectedItem';
                changeValue = changes.selectedItem;
            }
            else if ('selectedItems' in changes) {
                changeName = 'selectedItems';
                changeValue = changes.selectedItems;
            }
            var customEvent = Object.create(new Event('selectEvent'), {
                target: {
                    value: {
                        name: changeName,
                        value: changeValue,
                        type: 'combobox',
                    },
                },
            });
            onChange(customEvent, changeValue);
        }
    }
};
exports.sharedOnSelectedItemChange = sharedOnSelectedItemChange;
/**
 * Function for `onStateChange` shared between SingleSelect and MultiSelect
 * @param state - internal select state from Downshift
 * @param onInternalStateChange - onInternalStateChange function provided by the consumer
 * @param onInputChange - onInputChange function provided by the consumer
 */
var sharedOnStateChange = function (state, onInternalStateChange, onInputChange) {
    if (onInternalStateChange) {
        onInternalStateChange(state);
    }
    if ('inputValue' in state) {
        if (onInputChange) {
            onInputChange(state.inputValue);
        }
    }
};
exports.sharedOnStateChange = sharedOnStateChange;
/**
 * Render an item value
 * @param item - item to be checked
 * @returns stringed version of an item when `itemToString` is not defined
 */
var determineItemValue = function (item) {
    switch (typeof item) {
        case 'string':
            return item;
        case 'number':
            return item.toString();
        default:
            if (item != null) {
                console.error('Item must be a string or number if itemToString is not defined');
            }
            return '';
    }
};
exports.determineItemValue = determineItemValue;
/**
 * Convert an item to an ID or string
 * @param itemToID - function to convert item to ID
 * @param renderItemToString - function to convert item to string
 * @param item - item to be checked
 * @returns ID version of an item if `itemToID` is defined,
 * otherwise stringed version of an item
 */
var setupSafelyCallItemToID = function (itemToID, renderItemToString, item) {
    if (item === undefined || item === null) {
        return item;
    }
    if (itemToID) {
        return itemToID(item);
    }
    else {
        return typeof item === 'string' ? item : renderItemToString(item);
    }
};
exports.setupSafelyCallItemToID = setupSafelyCallItemToID;
/**
 * Recursively checks all parent elements for a css overflow property of auto or scroll.
 * @param element start with this element
 * @returns the parent scroll element
 */
var findScrollContainer = function (element) {
    if (!element) {
        return undefined;
    }
    var parent = element.parentElement;
    while (parent) {
        var overflow = window.getComputedStyle(parent).overflow;
        if (overflow.split(' ').some(function (o) { return o === 'auto' || o === 'scroll'; })) {
            return parent;
        }
        parent = parent.parentElement;
    }
    return document.documentElement;
};
exports.findScrollContainer = findScrollContainer;
